import styled from '@emotion/styled'
import { keyframes } from '@emotion/core'

const pulse = keyframes`
  0%,100%,80% {
    opacity: 0;
    transform: scale(.8)
  }

  40% {
    opacity: 1;
    transform: scale(1)
  }
`

const Box = styled.div({
  display: 'flex',
  justifyContent: 'space-around',
  width: 30,
  mx: 'auto',
  'div:nth-of-type(1)': {
    animationDelay: '-.2s',
  },
  'div:nth-of-type(2)': {
    animationDelay: '-.1s',
  },
})

const Dot = styled.div({
  width: 6,
  height: 6,
  backgroundColor: '#111',
  borderRadius: '50%',
  animation: `${pulse} .85s infinite ease-in-out`,
})

export function Loading() {
  return (
    <Box aria-label="loading-dots">
      <Dot />
      <Dot />
      <Dot />
    </Box>
  )
}
